// extracted by mini-css-extract-plugin
export default {"root":"AccountSettingsTabs_root__5EwmT","tab":"AccountSettingsTabs_tab__p6JJ2"};